/*
 * Module for interacting with API endpoints relating to the Citizen management feature
 */
import { apiDeleteVoid, apiEntityTasksAndCommentsBase, apiGet, apiPost, apiPutVoid } from "@/core/api";
export const apiCitizenInterventions = {
    getForCitizen: (citizenId) => apiGet(`citizens/${citizenId}/interventions`),
    create: (citizenId, intervention) => apiPost(`citizens/${citizenId}/interventions`, intervention),
    update: (citizenId, intervention) => apiPutVoid(`citizens/${citizenId}/interventions/${intervention.id}`, intervention),
    delete: (citizenId, interventionId) => apiDeleteVoid(`citizens/${citizenId}/interventions/${interventionId}`),
};
export const apiCitizenInterventionComments = (citizenId) => apiEntityTasksAndCommentsBase(`citizens/${citizenId}/interventions`);
